module.exports = __webpack_public_path__ + "img/treeLeaf.20fef53b.svg";